/* eslint-disable no-nested-ternary */

import PropTypes from 'prop-types';

import RichText from '../../../Core/RichText';
import OptimumStoresCollection from '../../Optimum/OptimumStoresCollection';

import { VendorHead, Vendor, Heading } from './styles';

const ColumnVendor = ({ dataItem = null, headers = '', columnCount = '' }) => {
  // * Null check for data
  if (!dataItem) return null;

  const filteredStores = dataItem.filter(
    item => item.__typename === 'ContentfulStore',
  );

  return (
    <>
      {dataItem[0].__typename === 'ContentfulProductChartColumn' ? (
        <VendorHead
          scope="row"
          role="cell"
          colSpan="1"
          columnCount={columnCount}
        >
          <Heading>
            <RichText document={dataItem[0].heading} />
          </Heading>
        </VendorHead>
      ) : null}
      {headers && columnCount === '4' ? (
        <Vendor
          headers={headers}
          colSpan="3"
          role="cell"
          columnCount={columnCount}
        >
          <OptimumStoresCollection stores={filteredStores} />
        </Vendor>
      ) : headers && columnCount === '5' ? (
        <Vendor
          headers={headers}
          colSpan="4"
          role="cell"
          columnCount={columnCount}
        >
          <OptimumStoresCollection stores={filteredStores} />
        </Vendor>
      ) : (
        <Vendor colSpan="2" role="cell" columnCount={columnCount}>
          <OptimumStoresCollection stores={filteredStores} />
        </Vendor>
      )}
    </>
  );
};

ColumnVendor.propTypes = {
  dataItem: PropTypes.arrayOf(PropTypes.shape()),
  headers: PropTypes.string,
  columnCount: PropTypes.string,
};

export default ColumnVendor;
